import angular, { IScope } from 'angular';
import uiRouter, { StateService } from '@uirouter/angularjs';
import { TODO } from '@b2b/types/core/utils';
import { ApiService } from '@b2b/common/services/api/types';

SelectAddressModalController.$inject = [
  '$scope',
  '$state',
  '$uibModalInstance',
  'ApiService',
  'ValidateService',
  'address',
  'contactId',
  'organizationId',
];
function SelectAddressModalController(
  $scope: IScope & { selectAddressModal: TODO },
  $state: StateService,
  $uibModalInstance: TODO,
  ApiService: ApiService,
  ValidateService: TODO,
  address: TODO,
  contactId: TODO,
  organizationId: TODO
) {

  const ctrl = {
    errors: [] as TODO[],

    isSubmitted: false,

    model: {} as TODO,
    organizationId: '',
    createAddress: false,
    address: false as TODO,
    viewId: $state.current.name,
    loadPreferences: $state.current.data.enablePreferences,

    init: function () {
      if (organizationId) {
        ctrl.organizationId = organizationId;
      }

      if (address) {
        ctrl.model = address;
      }

      $scope.$on('AddressCreate::Close', ctrl.onAddressCreateClose);
      $scope.$on('AddressCreate::Complete', ctrl.onAddressCreateComplete);
      $scope.$on('AddressList::Create', ctrl.onAddressListCreate);
      $scope.$on('AddressList::Select', ctrl.onAddressListSelect);
      $scope.$on('AddressList::Edit', ctrl.onAddressListEdit);
    },

    getAddress: function () {
      ApiService.organizations.contacts
        .detail({
          organizationId: organizationId,
          contactId: contactId,
        })
        .then(ctrl.success.getAddress, ctrl.error.getAddress);
    },

    isValid: function (field) {
      let r = true;

      if (ctrl.isSubmitted) {
        r = ValidateService.validate([
          {
            len: {
              value: ctrl.model[field],
            },
          },
        ]);
      }
      return r;
    },

    isValidEmail: function (email) {
      let r = true;

      if (ctrl.isSubmitted) {
        r = ValidateService.validate([{ email: email }]);
      }
      return r;
    },

    isValidPhone: function (phone) {
      let r = true;
      if (ctrl.isSubmitted) {
        r = ValidateService.validate([{ phone: phone }]);
      }
      return r;
    },

    done: function () {
      ctrl.isSubmitted = true;
      $scope.$broadcast('AddressCreate::Check');
      ctrl.prepareAddress();
      if (
        ValidateService.validate([
          { len: { value: ctrl.model.firstName } },
          { len: { value: ctrl.model.lastName } },
          { email: ctrl.model.email },
          { phone: ctrl.model.phoneNumber },
          { len: { value: ctrl.model.country } },
          { len: { value: ctrl.model.streetAddress1 } },
          { len: { value: ctrl.model.city } },
          { len: { value: ctrl.model.state } },
          { len: { value: ctrl.model.zipCode } },
        ])
      ) {
        $uibModalInstance.close(ctrl.model, ctrl.address);
      } else {
        ctrl.errors = [{ message: 'Please correct the errors below.' }];
      }

      if (ctrl.model) {
        $uibModalInstance.close(ctrl.model);
      } else {
        ctrl.errors = [{ message: 'You must select an address.' }];
      }
    },

    cancel: function () {
      $uibModalInstance.dismiss('cancel');
    },

    success: {
      getAddress: function (response) {
        // noop
      },
    },

    error: {
      getAddress: function (response) {
        console.error('Error retrieving address:', response);
      },
    },

    prepareAddress: function () {
      // Only replace if this is not a user model
      // Confusing but basically we either get an address with a user attached or we don't
      // This overloads the ID field so we need to differentiate here
      if (
        !ctrl.model.hasOwnProperty('email') &&
        !ctrl.model.hasOwnProperty('phoneNumber') &&
        !ctrl.model.hasOwnProperty('companyUrl')
      ) {
        ctrl.model.id = ctrl.address.id;
      }
      ctrl.model.addressId = ctrl.address.addressId;
      ctrl.model.streetAddress1 = ctrl.address.streetAddress1;
      ctrl.model.streetAddress2 = ctrl.address.streetAddress2;
      ctrl.model.city = ctrl.address.city;
      ctrl.model.state = ctrl.address.state;
      ctrl.model.zipCode = ctrl.address.zipCode;
      ctrl.model.country = ctrl.address.country;
      ctrl.model.isPrimary = ctrl.address.isPrimary;
    },

    onAddressCreateComplete: function (e, data) {
      const self = $scope.selectAddressModal;

      ctrl.errors = [];

      if (data.select) {
        ctrl.createAddress = false;
        ctrl.address = data.address;
        ctrl.prepareAddress();
      }

      $scope.$broadcast('AddressList::Refresh', { address: ctrl.address });
    },

    onAddressCreateClose: function (e, data) {
      $scope.selectAddressModal.createAddress = false;
    },

    onAddressListEdit: function (e, data) {
      const self = $scope.selectAddressModal;

      ctrl.address = data.address;
      ctrl.createAddress = true;
    },

    onAddressListCreate: function (e, data) {
      const self = $scope.selectAddressModal;

      ctrl.address = {
        country: '',
        type: 'secondary',
      };

      ctrl.createAddress = true;
    },

    onAddressListSelect: function (e, data) {
      const self = $scope.selectAddressModal;

      if (data.selected) {
        ctrl.address = data.address;
        // Create addressId field from address object
        ctrl.address.addressId = ctrl.address.id;
      }
    },
  };

  $scope.selectAddressModal = ctrl;
  ctrl.init();
}

export const SelectAddressModalModule = angular
  .module('acme.view.application.partners.create.selectAddressModal.controllers', [
    uiRouter,
    'acme.common.service.api',
    'acme.common.service.validate',
  ])
  .controller('SelectAddressModalController', SelectAddressModalController).name;
